import { Pipe, PipeTransform } from '@angular/core';
import { formatTime } from '../../../shared/time';
import { CurrencyPipe } from '@angular/common';
@Pipe({
    name: 'timeKrFormat',
    standalone: false
})

export class TimeKrFormatPipe implements PipeTransform {
    constructor(private currencyPipe: CurrencyPipe) {}
    transform(hours: number, hourFormat: string = 'Timer', decimals?: number, inDeciminuts?: boolean, hideZero?: boolean): string {
        if (!hours && hours !== 0) { return ''; }
        if (hours === 0 && hideZero === true) {
            return '';
        }
        if (hourFormat === 'Timer' && !inDeciminuts) {
            return formatTime(hours);
        }
        if (hourFormat === 'TKR') {
            return this.currencyPipe.transform(hours / 1000, 'DKK', '', `1.${decimals}-${decimals}`, 'da');
        }
        if (hourFormat === 'KR') {
            return this.currencyPipe.transform(hours, 'DKK', '', `1.${decimals}-${decimals}`, 'da');
        }
        return hours.toFixed(decimals);
    }
}
